import { render } from "./LogoIcon.vue?vue&type=template&id=a7f7e9e8&ts=true"
import script from "./LogoIcon.vue?vue&type=script&lang=ts"
export * from "./LogoIcon.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/webapp/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__